import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Redirect, withRouter} from 'react-router';
import {bindActionCreators} from 'redux';
import {setCalculation, setWebRelaunchStyleEnabled} from '../../../actions/common/action-creators';
import cyberSourceActions from '../../../actions/cybersource';
import {isWebRelaunchStyleCookieOn} from '../../../utils/helpers';
import localiseUrl from '../../../utils/localiseUrl';
import {
    getAvailableLanguageCodes,
    getCountryCode,
    getGenericError,
    getLanguageCode,
    getPaymentSessionId,
    getTranslations,
    getTracking,
    getPlatformData,
    getCustomer,
    getCalculation
} from '../../../utils/selectors';
import Spinner from '../../atoms/Spinner';
import {pushAnalyticsEvent} from '../../organisms/Analytics';
import {setPageLoadEvent} from '../../organisms/Analytics/pageLoadEvent';
import Cybersource from '../CyberSource/cybersource.component';
import {areVendorsLoaded, areVendorsReady} from '../CyberSource/cybersource.selectors';

export class CybersourceFormWrapper extends Component {
    static needs(store, options) {
        return [
            cyberSourceActions.loadCyberSourceInit(options),
            setWebRelaunchStyleEnabled(isWebRelaunchStyleCookieOn(options.cookies)),
            setCalculation(options.session.calculation)
        ].map(store.dispatch);
    }

    unsubcribeCardinal = null;

    componentDidMount() {
        const {
            cyberSourceData,
            actions,
            countryCode,
            paymentSessionId,
            tracking,
            customer,
            platformData,
            calculation
        } = this.props;

        if (!areVendorsLoaded({cyberSourceData})) {
            actions.loadCyberSourceInitAndSetupCardinal({languageCode: countryCode, paymentSessionId})
                .then(unsubscribe => {
                    this.unsubcribeCardinal = unsubscribe;
                });
        } else {
            this.unsubcribeCardinal = actions.setupCardinal(paymentSessionId);
        }

        setPageLoadEvent({
            provider: 'cybersource',
            tracking,
            customer,
            platformData,
            calculation
        });
    }

    componentWillUnmount() {
        this.unsubcribeCardinal?.();
    }

    setCybersourceVisibility = () => {
        if (this.props.genericError) {
            return;
        }
        pushAnalyticsEvent({
            interactionName: 'card payment interaction',
            cardPaymentAction: 'add new card'
        });
    }

    render() {
        const {
            redirectUrl,
            isLoaded,
            genericError,
            location
        } = this.props;


        if (redirectUrl) {
            return <Redirect to={redirectUrl} />;
        }

        if (!isLoaded) {
            return (
                <div className="main-spinner">
                    <Spinner />
                </div>
            );
        }

        return (
            <Cybersource
                genericError={genericError}
                setCybersourceVisibility={this.setCybersourceVisibility}
                location={location}
            />
        );
    }
}


CybersourceFormWrapper.propTypes = {
    countryCode: PropTypes.string.isRequired,
    cyberSourceData: PropTypes.shape().isRequired,
    translations: PropTypes.shape({}).isRequired,
    isLoaded: PropTypes.bool.isRequired,
    redirectUrl: PropTypes.string,
    paymentSessionId: PropTypes.string.isRequired,
    actions: PropTypes.shape({
        loadCyberSourceInit: PropTypes.func.isRequired,
        loadCyberSourceInitAndSetupCardinal: PropTypes.func,
        setupCardinal: PropTypes.func
    }).isRequired,
    location: PropTypes.shape({
        pathname: PropTypes.string.isRequired,
        search: PropTypes.string.isRequired
    }).isRequired,
    match: PropTypes.shape({}).isRequired,
    genericError: PropTypes.bool,
    calculation: PropTypes.shape()
};

CybersourceFormWrapper.defaultProps = {
    redirectUrl: null,
    genericError: false,
    calculation: null
};

const mapStateToProps = (state, props) => {
    const languageCode = getLanguageCode(state);
    const availableLanguageCodes = getAvailableLanguageCodes(state);
    const {redirectUrl} = state.cyberSourceData.data;

    return {
        countryCode: getCountryCode(state),
        cyberSourceData: state.cyberSourceData,
        translations: getTranslations(state),
        isLoaded: areVendorsReady(state),
        redirectUrl: localiseUrl(redirectUrl, languageCode, availableLanguageCodes),
        paymentSessionId: getPaymentSessionId(props),
        genericError: getGenericError(state),
        tracking: getTracking(state),
        customer: getCustomer(state),
        platformData: getPlatformData(state),
        calculation: getCalculation(state)
    };
};

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({...cyberSourceActions}, dispatch)
});

export const ConnectedCybersourceFormWrapper = connect(mapStateToProps, mapDispatchToProps)(CybersourceFormWrapper);

export default withRouter(ConnectedCybersourceFormWrapper);
